import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { FilterIcon } from 'foundations-assets';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { useEffect, useState } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import once from 'transmute/once';
import { BOOLEAN, DATE, DATE_TIME, ENUMERATION, NUMBER, STRING } from 'customer-data-objects/property/PropertyTypes';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const getOptions = once(() => {
  return [{
    value: BOOLEAN,
    label: I18n.text('customerDataFiltersUI.dataExplorer.typeFilter.propertyTypes.boolean')
  }, {
    value: DATE,
    label: I18n.text('customerDataFiltersUI.dataExplorer.typeFilter.propertyTypes.date')
  }, {
    value: DATE_TIME,
    label: I18n.text('customerDataFiltersUI.dataExplorer.typeFilter.propertyTypes.dateTime')
  }, {
    value: ENUMERATION,
    label: I18n.text('customerDataFiltersUI.dataExplorer.typeFilter.propertyTypes.enumeration')
  }, {
    value: NUMBER,
    label: I18n.text('customerDataFiltersUI.dataExplorer.typeFilter.propertyTypes.number')
  }, {
    value: STRING,
    label: I18n.text('customerDataFiltersUI.dataExplorer.typeFilter.propertyTypes.string')
  }];
});
const containsSameValues = (arr1, arr2) => {
  if (arr1.length !== arr2.length) {
    return false;
  }
  return arr1.every(item => arr2.includes(item));
};
function PropertyTypeFilter({
  disabled,
  tooltipContent,
  onChange,
  values
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const options = getOptions();
  useEffect(() => {
    setSelectedValues(values);
  }, [values, isOpen]);
  const handleApply = () => {
    setIsOpen(false);
    onChange(selectedValues);
  };
  const addSelectedValue = value => {
    setSelectedValues(prev => [...prev, value]);
  };
  const removeSelectedValue = value => {
    setSelectedValues(prev => prev.filter(v => v !== value));
  };

  // Disable the last option, if you select all options there is no filtering
  const isOptionDisabled = value => options.length - 1 === selectedValues.length && !selectedValues.includes(value);
  return /*#__PURE__*/_jsx(Popover, {
    open: isOpen,
    placement: "bottom",
    content: {
      body: /*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.dataExplorer.typeFilter.label"
        }),
        children: /*#__PURE__*/_jsx(ToggleGroup, {
          name: "propertyTypes",
          children: options.map(({
            value,
            label
          }) => /*#__PURE__*/_jsx(Checkbox, {
            checked: selectedValues.includes(value),
            disabled: isOptionDisabled(value),
            onChange: evt => evt.target.checked ? addSelectedValue(value) : removeSelectedValue(value),
            children: label
          }, value))
        })
      }),
      footer: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Button, {
          size: "small",
          use: "tertiary",
          onClick: handleApply,
          disabled: containsSameValues(values, selectedValues),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFiltersUI.dataExplorer.typeFilter.confirm"
          })
        }), /*#__PURE__*/_jsx(Button, {
          use: "link",
          onClick: () => setIsOpen(false),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFiltersUI.dataExplorer.typeFilter.cancel"
          })
        })]
      })
    },
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: tooltipContent,
      disabled: !disabled,
      placement: "right",
      children: /*#__PURE__*/_jsx(IconButton, {
        placement: "right",
        onClick: () => setIsOpen(!isOpen),
        disabled: disabled,
        children: /*#__PURE__*/_jsx(FilterIcon, {})
      })
    })
  });
}
export default PropertyTypeFilter;